var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#CDF2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5071 11.4545V26H18.4318V14.3736H18.3466L15.0156 16.4616V13.7344L18.6165 11.4545H21.5071Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.9d47fc3b943d4a5f872450b07038c5ad.svg";
export { ForwardRef as ReactComponent };